<app-navbar></app-navbar>
<main>
    <h1>{{language.blogs.heading}}</h1>
    <div class="content">
        <a [routerLink]="blog.link" *ngFor="let blog of filteredBlogs">
            <img src="{{blog.image_name}}" alt="blog-img">
            <h3>{{blog.title}}</h3>
        </a>
    </div>
</main>
<app-footer></app-footer>